<div class="wrapper">
	@if (!isError && data && data.getFee().fee) {
		@let vsnFeeBenefitFF = vsnFeeBenefitFF$ | async;
		@let showFeesUsingVisionBenefit =
			data.getVsnFeeTokenCollection()?.globalOptIn &&
			data.getVsnFeeTokenCollection()?.eligibleForVsn &&
			data.getVsnFeeTokenCollection()?.visionFeeDetail?.hasEnoughFunds &&
			data.getVsnFeeTokenCollection()?.enabled;

		<dl class="fee-transparency">
			<dt
				>{{
					(isSell ? "fee_transparency_details_sell_volume" : "fee_transparency_details_buy_volume")
						| translate
				}}
				@if (isTaxable) {
					<span
						class="tooltip-tw bpi__icon-info"
						[bp-tooltip]="'trans_fee_tax_tooltip' | translate"
						position="bottom"></span>
				}
			</dt>
			<dd>{{
				data.getFee().fee.net | fiat_precision_symbol: { id: fiat?.getId(), currencies: [fiat], symbol: true }
			}}</dd>

			@if (isMtBuy) {
				<dt>{{ (isSell ? "trans_fee_sell_amount" : "trans_fee_buy_amount") | translate }}</dt>
				<dd>{{
					mtBuyAmount
						| tradable_precision_symbol: { id: tradable.getId(), ignorePrecision: true, txPrecision: true }
				}}</dd>
			} @else {
				<dt>{{ (isSell ? "trans_fee_sell_amount" : "trans_fee_buy_amount") | translate }}</dt>
				<dd>{{
					data.getAmountTradable()
						| tradable_precision_symbol: { id: tradable.getId(), ignorePrecision: true, txPrecision: true }
				}}</dd>
			}

			<dt>{{ "trans_fee_offer_price" | translate }}</dt>
			<dd>{{
				data.getFee()?.fee?.priceWithoutFee
					| fiat_precision_symbol
						: {
								id: fiat?.getId(),
								currencies: [fiat],
								symbol: true,
								customPrecision: tradable.getPrecisionFiat()
						  }
			}}</dd>
			<!-- Normal summary (no VSN benefit) if FF is off OR VSNTokenCollection === null -->
			@if (!vsnFeeBenefitFF || !showFeesUsingVisionBenefit) {
				<dt>{{ "trans_fee_trade" | translate }}</dt>
				<dd>{{
					data.getFee().fee.fiat
						| fiat_precision_symbol: { id: fiat?.getId(), currencies: [fiat], symbol: true }
				}}</dd>
			}
			<!-- Normal summary (no VSN benefit) -->
		</dl>

		<!-- VSN fee transparency detail -->
		@if (vsnFeeBenefitFF && showFeesUsingVisionBenefit) {
			<vision-fee-trans-detail-ui
				[fiat]="fiat"
				[tradable]="tradable"
				[vsnFeeCollection]="data.getVsnFeeTokenCollection()"
				[fee]="+data.getFee().fee.fiat"
				[type]="data.getType()" />
		}

		<!-- VSN fee transparency detail -->
	} @else {
		<p class="error">{{ "fee_transparency_data_error" | translate }}</p>
	}
	<p class="description">{{ "trans_fee_description" | translate }}</p>
</div>
